import React from 'react';
import './agentCommissionSearch.less';
import './agentCommissionSearch.mobile.less';
import { AgentAdditionalInfo } from '../../modules/ShoppingCart/agentActions/AgentActions';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { PriceView } from '../../hooks/useGetGrossPrice';
import { Tooltip } from 'antd';
import useIsOperator from '../../hooks/useIsOperator';
import { TenantTsType } from '@skygroup/shared/constants/tenantTs';
import { getTsTypeByIdentifier } from '@skygroup/shared/utils/flightIdentifier';

/** What the agent is selling: a charter (ALP / Sky360 inventory) or a scheduled GDS flight (Amadeus); else nothing */
export type FlightKind = 'charter' | 'gds';

export const getFlightKind = (identifier?: string): FlightKind | undefined => {
  const tsType = identifier ? getTsTypeByIdentifier({ identifier, type: 'flight' }) : undefined;
  if (tsType === TenantTsType.ALP || tsType === TenantTsType.SKY) return 'charter';
  if (tsType === TenantTsType.AMADEUS) return 'gds';
  return undefined;
};

interface Props {
  centered?: boolean;
  marginTop?: number;
  agentAdditionalInfo?: AgentAdditionalInfo;
  isMoreDealsVisible?: boolean;
  isInInternalPackageBox?: boolean;
  /** chip: a light one-line chip inside a card row (a two-one-ways leg) instead of the tab under the card */
  variant?: 'tab' | 'chip';
  /** flights: charter / scheduled (GDS) - shown next to the supplier */
  flightKind?: FlightKind;
}

const AgentCommissionSearch = ({
  centered = false,
  marginTop = 0,
  agentAdditionalInfo,
  isMoreDealsVisible,
  isInInternalPackageBox,
  variant = 'tab',
  flightKind,
}: Props) => {
  const { agentMode, agent } = useSelector(
    (data: RootState) => data.config.agentInfo
  );
  const { agentCommission: t } = useSelector(
    (data: RootState) => data.config.translations
  );

  const isOperator = useIsOperator();
  const price_view = agent?.price_view;

  // Operators have no commission (see useIsOperator) — in practice
  // agentAdditionalInfo is already absent for them, but be explicit so this
  // stays hidden if sky360-ms ever starts sending it.
  if (!agentMode || isOperator || !(agentAdditionalInfo?.supplier_name && agentAdditionalInfo?.suggested_commission)) {
    return null;
  }

  return (
    <div
      className={`agent-commission-search ${
        variant === 'chip'
          ? 'chip-view'
          : isInInternalPackageBox
          ? 'internal-package-box-view'
          : 'default-view'
      } ${centered ? 'centered' : ''} ${
        isMoreDealsVisible ? 'isMoreDealsVisible' : ''
      }`}
      style={{
        marginTop: marginTop,
      }}
    >
      <div className="supplier">
        <b>{t.supplier}: </b>
        <span>{agentAdditionalInfo?.supplier_name}</span>
        {flightKind && (
          <span className={`flight-kind flight-kind--${flightKind}`}>
            {flightKind === 'charter' ? t.charterFlight : t.gdsFlight}
          </span>
        )}
      </div>
      <div className="commission">
        {/* <Tooltip
          title={
            price_view === PriceView.Net
              ? `${agentAdditionalInfo?.suggested_commission} ${t.commission}`
              : ''
          }
        > */}
        <b>
          {price_view === PriceView.Net ? t.netPrice : t.commission}
          {price_view === PriceView.Gross ? ': ' : ''}
        </b>
        {/* </Tooltip> */}

        {price_view === PriceView.Gross && (
          <span>{agentAdditionalInfo?.suggested_commission}%</span>
        )}
      </div>
    </div>
  );
};

export default AgentCommissionSearch;
